<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte';
    import { t } from 'svelte-i18n';
    import { fetchDocumentos, saveDocumento, removeDocumento, searchDocumentos, subscribeToDocumentos, unsubscribeFromDocumentos, fetchImpuestoDocumento } from '../controllers/documentoController.js';
    import { fetchSucursales } from '../controllers/sucursalController.js';

    // Configuración de las columnas para la tabla de documentos
    let documentoColumns = [
      { label: 'Sucursal', field: 'sucursal_descrip', type: 'text' },
      { label: $t('fields.description'), field: 'descrip', type: 'text'  },
      { label: 'Tipo', field: 'tipo', type: 'text'  },
      { label: $t('fields.state'), field: 'sta', type: 'bool' },
      { label: 'Correlativo', field: 'correlativo', type: 'number' },
    ];

    // Estructura del nuevo objeto Documento
    let newDocumento = {
      sucursal: '', 
      descrip: '',
      tipo: '',      // Campo tipo
      sta: true,
      correlativo: null, // Auto increment
      afecto_iva: false,
      formato: null, // Puede ser nulo
      impuestos: [], // Impuestos

    };

    // Configuración de los campos para la edición de documentos
    let editColumns = [
      { label: 'Sucursal', key: 'sucursal', type: 'select', required: true, fetchOptions: { key: 'id', value: 'descrip' }, options: [] },
      { label: $t('fields.description'), key: 'descrip', type: 'text', required: true },
      { label: 'Tipo', key: 'tipo', type: 'select', required: true, options: [
          { key: 'compra', value: 'Compra' },
          { key: 'venta', value: 'Venta' },
          { key: 'ingreso', value: 'Ingreso' },
          { key: 'asset', value: 'Asset' },
          { key: 'dev_compra', value: 'Devolución Compra' },
          { key: 'dev_venta', value: 'Devolución Venta' },
          { key: 'cotizacion', value: 'Cotización' },
          { key: 'o_compra', value: 'Orden de Compra' },
          { key: 'abono_cxc', value: 'Abono CXC' },
          { key: 'abono_cxp', value: 'Abono CXP' },
          { key: 'traslados', value: 'Traslados' },
          { key: 'fc_especial', value: 'FC Especial' },
          { key: 'requisicion_entrada', value: 'Requisición Entrada' },
          { key: 'requisicion_salida', value: 'Requisición Salida' },
          { key: 'anticiposclientes', value: 'Anticipos Clientes' },
          { key: 'anticiposproveedor', value: 'Anticipos Proveedor' },
          { key: 'duca', value: 'DUCA' },
          { key: 'prorrateo', value: 'Prorrateo' },
          { key: 'transformacion', value: 'Transformación' },
        ]
      },
      { label: 'Formato', key: 'formato', type: 'text', required: false },
      { label: $t('fields.state'), key: 'sta', type: 'checkbox', required: true },
      { label: 'Afecto IVA', key: 'afecto_iva', type: 'checkbox', required: false },
    ];

    // Opciones de sucursales
    let sucursalOptions = [];

    // Función para cargar y transformar sucursales
    async function loadSucursales() {
        try {
            const fetchedSucursales = await fetchSucursales();

            if (Array.isArray(fetchedSucursales.sucursal)) {
                sucursalOptions = fetchedSucursales.sucursal.map(e => ({
                    key: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.key],
                    value: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.value],
                }));

                // Asigna las opciones transformadas a las columnas editables
                editColumns.find(column => column.key === 'sucursal').options = sucursalOptions;
            } else {
                console.error('Se esperaba un array de sucursales, pero se obtuvo:', fetchedSucursales);
            }
        } catch (error) {
            console.error('Error al cargar las sucursales:', error);
        }
    }

    // Cargar las sucursales al montar el componente
    onMount(() => {
        loadSucursales();
    });
</script>

<CRUD 
    title={$t('entities.documentos')}
    entityName="documento"
    newEntity={newDocumento}
    columns={documentoColumns}
    fetchEntities={fetchDocumentos}
    saveEntity={saveDocumento}
    removeEntity={removeDocumento}
    searchEntities={searchDocumentos}
    subscribeToChanges={subscribeToDocumentos}
    unsubscribeFromChanges={unsubscribeFromDocumentos}
    editColumns={editColumns}
    fetchImpuestos={fetchImpuestoDocumento}
/>
